import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingDecorationProps {
  title: string;
  items: React.ReactNode;
}

export function NewbuildingDecoration({ items, title }: INewbuildingDecorationProps) {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['header']}>
        <UIHeading1 as="h2">{title}</UIHeading1>
      </div>

      <div className={styles['container']}>{items}</div>
    </div>
  );
}
